const cities = {
    "jerusalem": "ירושלים",
    "sderot": "שדרות"
}

export const citiesOptions = [{ id: "jerusalem", label: cities.jerusalem }, { id: "sderot", label: cities.sderot }]

export default cities